export const _setEpisodeSAPStartDate = (state, action) => {
  state.newEpisode.episodeSAPStartDate = action.payload;
};

export const _setEprd = (state, action) => {
  state.newEpisode.expectedEPRD = action.payload;
};

export const _setActualAPRD = (state, action) => {
  state.newEpisode.actualAPRD = action.payload;
};

export const _setCDCNumber = (state, action) => {
  state.newEpisode.cDCNumber = action.payload;
};

export const _setEpisodeComment = (state, action) => {
  state.newEpisode.episodeComment = action.payload;
};

export const _setEpisodeDischargeDate = (state, action) => {
  state.newEpisode.episodeDischargeDate = action.payload;
};

export const _setTIR = (state, action) => {
  state.newEpisode.tIR = action.payload;
};

export const _setCCCMS = (state, action) => {
  state.newEpisode.cCCMS = action.payload;
};

export const _setInactivity = (state, action) => {
  state.newEpisode.inactivity = action.payload;
};

export const _setIncarcerationInstitution = (state, action) => {
  state.newEpisode.incarcerationInstitutionId = action.payload;
};

export const _setReferralSource = (state, action) => {
  state.newEpisode.referralSourceId = action.payload;
};

export const _setLastCountyofResidence = (state, action) => {
  state.newEpisode.lastCountyofResidenceId = action.payload;
};

export const _setParoleCounty = (state, action) => {
  state.newEpisode.paroleCountyId = action.payload;
};

export const _setParoleAgent = (state, action) => {
  state.newEpisode.paroleAgentId = action.payload;
};

export const _setArea = (state, action) => {
  state.newEpisode.areaId = action.payload;
};

export const _setEpisodeDischargeReason = (state, action) => {
  state.newEpisode.episodeDischargeReasonId = action.payload;
};
